import { Injectable } from '@angular/core';

import { Effect, Actions, ofType } from '@ngrx/effects';
import { map, switchMap, catchError, mergeMap } from 'rxjs/operators';

import * as userActions from '../actions/user';
import { RestService } from '../../service/rest.service';
import { toPayload } from './BaseEffects';
import { AppUser } from '../../models/user.model';

// test user with test data
const testUser: AppUser = <AppUser>{};
testUser.name = 'Administrator';
testUser.email = 'admin@admin.ru';
testUser.isLogged = false;
// testUser.avatarLink = 'assets/img/portrait/small/avatar-s-5.png';
// testUser.lastVisit = new Date().getTime();


@Injectable()
export class UserEffects {

  constructor(
    private actions$: Actions,
    private restService: RestService
  ) {}

  @Effect()
  loginUser$ = this.actions$.pipe(
    ofType<userActions.Login>(userActions.USER_LOGIN),
    map(toPayload),
    switchMap((credentials) => {
      return this.restService
        .authenticate(credentials.login, credentials.password)
        .pipe(
          mergeMap((item: AppUser) => [
            new userActions.LoginSuccess(item)
            // new messageActions.SuccessMessage(AppMessages.HTML_UPDATE_SUCCESS)
          ]),
          catchError(error => [
            new userActions.LoginFail(error),
            // new messageActions.ErrorMessage(AppMessages.USER_LOGIN_FAIL)
          ])
        );
    })
  );
}
